import { createContext, useContext, useState, useCallback } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(localStorage.getItem("lang") || "en");
  const setLang = useCallback((l, save = true) => {
    setLangState(l);
    localStorage.setItem("lang", l);
    if (save) api.put("/me/prefs", { lang: l }).catch(() => {});
  }, []);
  const t = useCallback((en, es) => (lang === "es" ? es ?? en : en), [lang]);
  return <Ctx.Provider value={{ lang, setLang, t }}>{children}</Ctx.Provider>;
}

export const useLang = () => useContext(Ctx);
